import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNil from "lodash/isNil";

var StyleAttribute = function () {
  function StyleAttribute(options) {
    var _this = this;

    _classCallCheck(this, StyleAttribute);

    _defineProperty(this, "name", void 0);

    _defineProperty(this, "type", void 0);

    _defineProperty(this, "scale", void 0);

    _defineProperty(this, "descriptor", void 0);

    _defineProperty(this, "featureBufferLayout", []);

    _defineProperty(this, "needRescale", false);

    _defineProperty(this, "needRemapping", false);

    _defineProperty(this, "needRegenerateVertices", false);

    _defineProperty(this, "featureRange", {
      startIndex: 0,
      endIndex: Infinity
    });

    _defineProperty(this, "vertexAttribute", void 0);

    _defineProperty(this, "defaultCallback", function (params) {
      if (params.length === 0) {
        var _this$scale;

        return ((_this$scale = _this.scale) === null || _this$scale === void 0 ? void 0 : _this$scale.defaultValues) || [];
      }

      return params.map(function (param, idx) {
        var _this$scale2;

        var scaleFunc = (_this$scale2 = _this.scale) === null || _this$scale2 === void 0 ? void 0 : _this$scale2.scalers[idx].func;
        var value = scaleFunc(param);
        return value;
      });
    });

    this.setProps(options);
  }

  _createClass(StyleAttribute, [{
    key: "setProps",
    value: function setProps(options) {
      Object.assign(this, options);
    }
  }, {
    key: "mapping",
    value: function mapping(params) {
      var _this$scale3;

      if ((_this$scale3 = this.scale) !== null && _this$scale3 !== void 0 && _this$scale3.callback) {
        var _this$scale4;

        var ret = (_this$scale4 = this.scale) === null || _this$scale4 === void 0 ? void 0 : _this$scale4.callback.apply(_this$scale4, _toConsumableArray(params));

        if (!_isNil(ret)) {
          return [ret];
        }
      }

      return this.defaultCallback(params);
    }
  }, {
    key: "resetDescriptor",
    value: function resetDescriptor() {
      if (this.descriptor) {
        this.descriptor.buffer.data = [];
      }
    }
  }]);

  return StyleAttribute;
}();

export { StyleAttribute as default };
//# sourceMappingURL=StyleAttribute.js.map